module.exports = __webpack_public_path__ + "static/media/houston.b2926caf.png";